module.exports = require("@swa-ui/dotcom/src/placements/LuvStoriesPlacement/LuvStoriesPlacement.module.scss");